import React, { createContext } from 'react';
import { node } from 'prop-types';
import {
  extend
} from '@thd-nucleus/data-sources';

import { useEstimateApi } from '../hooks/useEstimateApi';
import { GET_RENTAL_ESTIMATE_DATA_MODEL, GET_RENTAL_DELIVERY_ESTIMATE_DATA_MODEL } from '../utils/dataModels';

export const defaultContext = {
  data: null,
  loading: false,
  error: '',
  executeRequest: async () => {}
};

export const EstimateApiContext = createContext(defaultContext);

const EstimateApiProvider = ({
  children
}) => {
  return (
    <EstimateApiContext.Provider
      value={{ ...useEstimateApi() }}
    >
      {children}
    </EstimateApiContext.Provider>
  );
};

EstimateApiProvider.propTypes = {
  children: node.isRequired
};

export default EstimateApiProvider;

EstimateApiProvider.dataModel = extend(GET_RENTAL_ESTIMATE_DATA_MODEL, GET_RENTAL_DELIVERY_ESTIMATE_DATA_MODEL);
